export const taxRates = {
    TN: 'Taux Normal',
    TI: 'Taux Intermédiaire',
    TR: 'Taux Réduit',
    TP: 'Taux Particulier',
    NS: 'Taux exonéré',
    default: 'Pas de taux',
} as const;

export const articleUnits = {
    F: 'Forfait',
    C: 'Caractère',
    U: 'Unité',
    L: 'Ligne',
    default: "Pas d'unité pour cet article",
} as const;

export const domainIds = {
    formality: 3,
} as const;
